// extracted by mini-css-extract-plugin
export default {"staticImageMapWrapper":"StaticImageMap_staticImageMapWrapper__IRgoM","staticImageMap":"StaticImageMap_staticImageMap__z-qkp"};